import { useEffect, useState } from 'react';
import { api } from '../api.ts';
import { describeError } from '../api.ts';

const CHANGED_EVENT = 'studio:changed';

/** Tells every open view that data changed so counts and lists reload. */
export function announceChange(): void {
  window.dispatchEvent(new Event(CHANGED_EVENT));
}

/** A number that increases on every change; use it as a dependency to reload. */
export function useChanges(): number {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const onChange = () => setVersion((v) => v + 1);
    window.addEventListener(CHANGED_EVENT, onChange);
    return () => window.removeEventListener(CHANGED_EVENT, onChange);
  }, []);
  return version;
}

type Toast = (kind: 'success' | 'error' | 'info', message: string) => void;

/** Runs a write operation, shows a toast either way, and announces the change. Returns the result or null on failure. */
export async function runWrite<T>(toast: Toast, name: string, input: unknown, success: string | ((result: T) => string)): Promise<T | null> {
  try {
    const result = await api.op<T>(name, input);
    toast('success', typeof success === 'function' ? success(result) : success);
    announceChange();
    return result;
  } catch (error) {
    toast('error', describeError(error));
    return null;
  }
}
